import { API_SITE_CORPO } from "../api_endpoint";
import { http, httpLogin,httpwithtoken } from '../http';

export const login = async (credentials:any) => {
  // console.log(credentials)
  let response = await httpLogin.post(API_SITE_CORPO.LOGIN, credentials);
  // console.log(response)
  return response;
};

export const me = async ( ) => {
 
  let response = await httpwithtoken.get(API_SITE_CORPO.ME);
  // console.log(response)
  return response;
};



